import script from "./BaseTag.vue?vue&type=script&lang=ts"
export * from "./BaseTag.vue?vue&type=script&lang=ts"

export default script